const  locationReducer = (state={}, action) => {
    switch (action.type) {
      case 'LIST_CITIES':
        return {...state, cities: action.cities}
          
      default: 
        return state
    }
}
export default  locationReducer;